var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.productsInCart.length > 0 && _vm.webstoreContent
    ? _c(
        "div",
        { attrs: { id: "offers-in-cart" } },
        _vm._l(_vm.productsInCart, function (offer) {
          return _c(
            "div",
            { key: offer, staticClass: "selected-offer" },
            [_c("Offer", { attrs: { offer: offer, editable: _vm.editable } })],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }